import { Component, Input } from '@angular/core';
import { DynamicBlocks } from './block-builder.types';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { TranslateModule } from '@ngx-translate/core';
import { CommentBlockComponent } from '../shared/comment-block/comment-block.component';

@Component({
  selector: 'sm-block-builder',
  imports: [CommonModule, ButtonModule, TextareaModule, FormsModule, FileUploadModule, TranslateModule, CommentBlockComponent],
  templateUrl: './block-builder.component.html',
  styleUrl: './block-builder.component.scss',
})
export class BlockBuilderComponent {
  @Input() blocks?: DynamicBlocks;

  dropdownOpen: Record<string, boolean> = {};

  toggleDropdown(id: string) {
    this.dropdownOpen[id] = !this.dropdownOpen[id];
  }
}
